import React, { useContext, useState } from 'react';
// import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

import { classes, LevelButtons, IconArrowRight, fontDefaultAlt, fontkoKR } from '@mirinae/react-ui';
import { os } from '@mirinae/js-utils/utils/userAgent';
import GTM from '@mirinae/apis/GoogleAnalytics';

import { postLessonEvent } from '@mirinae/lessons/modules/libs/lessonLib';
// import IconPlay from '@mirinae/lessons/components/lesson/icons/IconPlay';
// import IconPause from '@mirinae/lessons/components/lesson/icons/IconPause';
// import IconComplete from '@mirinae/lessons/components/lesson/icons/IconComplete';
import LessonsContext from '@mirinae/lessons/modules/contexts/lessons';
import { LessonButton } from '@mirinae/lessons/modules/defines/styles';
import { lessonsBreakPoint, fontDefault, lessonsPalette } from '@mirinae/lessons/modules/defines/styles';
// import { apiPaths, lessonsPaths, explorerPaths, membersPaths, authPaths} from '@mirinae/shared/defines/paths';
// import httpAPI from '@mirinae/lessons/modules/apis/http';
import IconLock from '@mirinae/lessons/components/svg/icon-lock.svg';
import IconClock from '@mirinae/lessons/components/svg/icon-clock-white.svg';
import PopupDialog from '@mirinae/lessons/editor/components/ui/PopupDialog';
import { useProAccessStoreMethods } from '@mirinae/stores/proAccessStore';
import { featureFor } from '@mirinae/shared/stores/proAccessStore';
import { authPaths, lessonsPaths, navigateExternal } from '@mirinae/defines/paths';

export const LessonCardWrapper = styled.div`
    position: relative;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    height: 250px;
    margin: 0 10px 20px;
    border: 1px solid ${lessonsPalette.grey[5]};
    border-radius: 10px;
    background-color: ${lessonsPalette.primary.white};
    background-attachment: fixed;
    // overflow: hidden; // for display orange N icon
    box-shadow: inset 6px 5px 20px rgba(244, 244, 244, 0.25), inset -6px -5px 20px rgba(186, 186, 186, 0.17);
    filter: drop-shadow(4px 2px 15px rgba(159, 188, 186, 0.2));
    ${props => props.theme === 'main' && `
        &:nth-child(n+6) {
            display: none;
        }
    `}
    ${props => props.stamp && `
        &::before{
            z-index: -1;
            content: '';
            position: absolute;
            top: 23px;
            right: 0;
            display: block;
            width: 116px;
            height: 177px;
            opacity: 0.1;
            background: url(/assets/lessons/images/img-stamp-completed-crop.png) no-repeat 0 0;
            background-size: 100% 100%;
        }
    `}
    
    ${props => (props.new && `
        :before {
            font-family: 'Montserrat';
            content: 'N';
            position: absolute;
            z-index: 2;
            right: -5px;
            top: -5px;
            display: block;
            width: 20px;
            height: 20px;
            line-height: 20px;
            border-radius: 50%;
            background-color: #FF8826;
            color: white;
            font-size: 10px;
            font-weight: 700;
            text-align: center;
        }
    `)}
    
    ${props => (props.ua === 'desktop' ? `
        width: 192px;
        &:hover {
            box-shadow: inset -1px -1px 1px ${lessonsPalette.primary.main}, inset 1px 1px 1px rgba(148, 208, 205, 0.53), inset 6px 5px 20px rgba(244, 244, 244, 0.25), inset -6px -5px 20px rgba(186, 186, 186, 0.17);
            filter: drop-shadow(4px 2px 15px rgba(159, 188, 186, 0.5));
        }
    ` : `
        width: calc(50% - 10px);
        margin: 0 5px 10px;
        @media only screen and (min-width: ${lessonsBreakPoint.sm}) {
            width: calc(25% - 10px);
        }
        @media only screen and (max-width: ${lessonsBreakPoint.xs}) {
            width: calc(100% - 10px);
        }
    `)}
`;

export const ProgressBar = styled.div`
    flex-shrink: 0;
    width: 100%;
    height: 7px;
    background: ${lessonsPalette.grey[5]};
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    overflow: hidden;
    &:before {
        content: '';
        display: block;
        width: ${props => (props.progress)}%;
        height: 100%;
        border-top-left-radius: 10px;
        background: ${props => (props.progress === 100 ? 'linear-gradient(90deg, #CBDF8D 0%, #ACC564 29.17%, #87B600 77.08%)' : 'linear-gradient(90deg, #c1e6e6 0%, #94d0cd 100%)')};
    }
    ${props => (props.ua === 'desktop' ? `
        width: calc(100% - 1px); // crude attempt at allowing hover green outline to continue around progress bar
    ` : `
        body:not(.mylessons) & {
            height: 5px;
        }
    `)}
`;
export const CardIndex = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 9px 15px 18px;
    cursor: pointer;
    .${classes.mobile}:not(.mylessons) & {
        padding: 15px;
    }
    ${props => props.type === 'xxisLocked' && (`
        &:before {
            content: '';
            display: block;
            position: absolute;
            inset: -7px 0 0;
            background: rgba(255, 255, 255, .75);
            border-radius: 10px;
        }
        &:after {
            content: '';
            position: absolute;
            right: 23px;
            bottom: 20px;
            width: 40px;
            height: 40px;
            background: url(${IconLock}) no-repeat;
        }
    `)}
    ${props => props.type === 'wait' && (`
        &:before {
            content: '';
            display: block;
            position: absolute;
            top: -7px;
            right: 0;
            bottom: 0;
            left: 0;
            background-color: rgba(151,151,151,.3);
        }
        &:after {
            content: 'COMING SOON';
            position: absolute;
            top: 57px;
            left: 50%;
            width: 90px;
            margin-left: -45px;
            padding-top: 100px;
            background: url(${IconClock}) no-repeat;
            color: ${lessonsPalette.primary.white};
            font-size: 16px;
            font-weight: 700;
            line-height: 20px;
            text-align: center;
            text-transform: uppercase;
        }
    `)}
    ${props => props.intro && (`
        background: url(/assets/lessons/images/lessoncard_start.png) no-repeat 0 0;
    `)} 
`;
const CardIndexHead = styled.div`
    display: flex;
    // flex-direction: row-reverse;

    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    height: 16px;
    cursor: pointer;
    & > svg {
        vertical-align: top;
        height: 14px;
    }
`;
const CardNumber = styled.div`
    font-size: 13px;
    color: ${lessonsPalette.grey[0]};
    span {
        color: ${lessonsPalette.grey[4]};
    }
`;
// const ArrowButton = styled(LessonButton)`
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     width: 15px;
//     height: 15px;
//     &:before {
//         content: '';
//         width: 0;
//         height: 0;
//         border-style: solid;
//         border-width: 8px 6.5px 0 6.5px;
//         border-color: #c4c4c4 transparent transparent transparent;
//     }
// `;
export const CardIndexBody = styled.div`
    padding-top: 36px;
    // .${classes.mobile}:not(.mylessons) & {
    //     padding-top: 32px;
    // }
`;
// export const CardButton = styled(Link)`
export const CardButton = styled(LessonButton)`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 47px;
    padding: 0 17px 0 14px;
    border-radius: 10px;
    background-color: ${props => (props.theme === 'start' ? lessonsPalette.default[0] : props.theme === 'complete' ? lessonsPalette.default[2] : lessonsPalette.default[5])};
    color: ${lessonsPalette.primary.white};
    font-size: 13px;
    font-weight: 700;
    font-family: ${fontDefaultAlt};
    text-transform: capitalize;

    // &:hover:not(:disabled) {
    //     background-color: ${props => (props.theme === 'start' ? lessonsPalette.darken[0] : props.theme === 'complete' ? lessonsPalette.darken[2] : lessonsPalette.darken[5])};    
    // }
    &:disabled {
        background-color: ${lessonsPalette.grey[5]};
    }

    span {
        display: block;
        // width: 82px;
        width: 100%;
        text-align: center;
        line-height: 100%;
        white-space: nowrap;
    }
    svg {
        width: 4px;
        height: 8px;
        margin-left: 10px;
        g {
            fill:${lessonsPalette.primary.white};
        }
    }
`;
const CardLabel = styled.div`
    margin-bottom: 5px;
    color: ${lessonsPalette.grey[4]};
    font-weight: 700;
    font-size: 14px;
    font-family: ${fontDefault};
    text-transform: uppercase;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    height: 23px;
    line-height: 23px;
`;
export const CardTitle = styled.div`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 60px;
    line-height: 28px;
    margin-bottom: 27px;
    color: ${lessonsPalette.grey[0]};;
    font-size: 20px;
    font-family: ${fontkoKR};
    font-weight: 500;
    overflow: hidden;
    ${props => props.replaced && 'text-decoration: line-through;'}
`;

// const CardList = styled.div`
//     display: flex;
//     flex-direction: column;
//     justify-content: space-between;
// `;
// const CardListTop = styled.div`
//     flex-shrink: 0;
//     display: flex;
//     align-items: center;
//     height: 37px;
//     padding: 10px 20px 0;
//     cursor: pointer;

//     .${classes.mobile}:not(.mylessons) & {
//         height: 42px;
//         padding: 10px 15px 0;
//     }

//     ${ArrowButton} {
//         transform: rotate(180deg);
//     }

//     & > svg {
//         flex-shrink: 0;
//         margin-right: 5px;
//         margin-top: -2px;
//     }
// `;
// const ListTitle = styled.div`
//     width: 100%;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     white-space: nowrap;
// `;
// const CardListItem = styled.div`
//     flex-shrink: 0;
//     height: 50px;
//     border-top: 1px solid #dfdfdf;

//     .${classes.mobile}:not(.mylessons) & {
//         height: 42px;
//     }

//     a {
//         display: flex;
//         align-items: center;
//         width: 100%;
//         height: 100%;
//         padding: 0 10px 0 20px;
//         font-family: ${fontDefaultAlt};
//         &:hover {
//             background-color: rgba(196, 196, 196, .3);
//         }
//         .${classes.mobile}:not(.mylessons) & {
//             padding-left: 15px;
//         }
//     }
//     svg {
//         flex-shrink: 0;
//         margin-right: 15px;
//         .${classes.mobile}:not(.mylessons) & {
//             margin-right: 10px;
//         }
//     }
// `;

// const SectionButton = styled(Link)`
//     cursor: pointer;
// `;

// const LessonState = props => {
//     switch (props.state) {
//     default:
//     case 'play':
//         return <IconPlay />;
//     case 'pause':
//         return <IconPause />;
//     case 'complete':
//         return <IconComplete />;
//     }
// };

export const stateMap = {
    start: { label: 'start', action: 'start', theme: 'start' },
    progressing: { label: 'continue', action: 'continue', theme: 'continue' },
    finished: { label: 'review', action: 'review', theme: 'complete' },
    reviewing: { label: 'reviewing', action: 'continue', theme: 'continue' },
    reviewed: { label: 'review', action: 'review', theme: 'complete' },
};


const AdminButton = styled(LessonButton)`
    position: absolute;
    color: ${props => (props.disabled ? 'red' : '#913481;')};
    width: 33%;
    z-index: 9999;
    &:hover {
        outline: thin solid #f26e66;
        border-radius: 10px;
    }
`;
const EditButton = styled(AdminButton)`
    bottom: 72px;
    left: 120px;
`;
const ResetButton = styled(AdminButton)`
    bottom: 72px;
    left: 11px;
`;
// const RetireButton = styled(AdminButton)`
//     bottom: 72px;
//     left: 68px;
// `;
const FigmaFilename = styled.div`
    position: absolute;
    font-size: 11px;
    text-align: center;
    color: #913481;;
    top: 36px;
    left: 22px;
    width: 80%;
    z-index: 9999;
`;

const EditorName = styled(FigmaFilename)`
    top: 28px;
`;
const ViewCount = styled(FigmaFilename)`
    top: 43px;
`;

const LessonCard = ({ data, user, state, progress, theme, type, number, viewCount }) => {
    const lessons = useContext(LessonsContext);
    const [showRetireConfirm, setShowRetireConfirm] = useState(false);
    const { hasAccess, displayUpgradeToProPopup, accessProFeatures } = useProAccessStoreMethods();

    // compute link into lesson based on lessonTracker.state & lastEvent page
    //     state:one of 'progressing', 'finished', 'reviewing', 'reviewed'
    const lessonLink = (lesson) => {
        let link = `${lessonsPaths.player}/${lesson._id}`;
        if (lesson.lessonTracker && lesson.lessonTracker.state.match(/progressing|reviewing/) && lesson.lastEvent.action.match(/next|complete/))
            link += `/${lesson.lastEvent.action === 'complete' ? lesson.lastEvent.context.page : lesson.lastEvent.details.to.page}`;
        return link;
    };

    const onClickCardButton = ({ lessonObject }) => {
        const { lessonNode } = lessonObject;
        if (lessonNode.status === 'Coming soon') {
            setDisplayModal('wait');
            GTM.userAction('click-coming-soon', { lesson: lessonNode.title }, 'lessons');
        } else {
            if (user?.role === 'guest') {
                if (window.ProfileChannel) {
                    window.ProfileChannel.postMessage(JSON.stringify({ command: 'signOut', value: true })); // webview
                } else if (window.flutter_inappwebview) {
                    window.flutter_inappwebview.callHandler('ProfileChannel', { command: 'signOut', value: true });
                } else {
                    navigateExternal(`${authPaths.login}?redirect=${lessonsPaths.home}`, { replace: true });
                }
            } else {
                // gather access info on the fly, too many lessons to pre-access all possible
                const accessor = { type: 'lesson', objectID: lessonObject._id, url: lessonLink(lessonObject) };
                const feature = featureFor(accessor);
                if (!hasAccess(user, feature) && !lessonNode.guestAccess) {
                    accessProFeatures([accessor], user)
                        .then(([accessKey]) => displayUpgradeToProPopup(accessKey));
                } else {
                    const action = stateMap[state].action;
                    postLessonEvent(lessonObject, { action, context: { lesson: lessonNode.nodeID } });
                    GTM.userAction(action, { lesson: lessonObject.title }, 'lessons');
                    navigateExternal(lessonLink(lessonObject)); // Flutter needs to see this page change
                }
            }
        }
    };

    // const sectionLink = (section, data) => `${lessonsPaths.player}/${data.lessonObject._id}/${data.sections.firstPageNodeIDs[section.title]}`;

    const resetLesson = async (e) => {
        e.stopPropagation();
        lessons.reset(data.lessonObject);
    };

    const editLesson = async (e) => {
        e.stopPropagation();
        lessons.editLesson(data.lessonObject);
    };

    const deleteLesson = (e) => {
        e.stopPropagation();
    };

    const testingTitle = `id:${data.lessonObject._id}, guid:${data.lessonObject.guid}, editor:${data.lessonObject.editor && data.lessonObject.editor.editedBy.name}`;

    const isNew = () => { // not yet started && published less than 7 days ago
        return state === 'start' && data.lessonObject.lessonNode.publishDate
            && Date.now() - data.lessonObject.lessonNode.publishDate < 7 * 24 * 60 * 60 * 1000;
    };

    return (
        <LessonCardWrapper new={isNew()} theme={theme} stamp={progress === 100} onClick={() => onClickCardButton(data)} ua={os.isOthers ? 'desktop' : 'mobile'}>
            <ProgressBar progress={progress || 0} ua={os.isOthers ? 'desktop' : 'mobile'} />
            {/* {isIndex ? ( */}
            <CardIndex type={type} intro={data.levelTitle === ''}>
                <CardIndexHead>
                    {/* <ArrowButton type="button" /> */}
                    <LevelButtons level={data.listingLabel && data.listingLabel.match(/idiom|preverb|neologism/i) ? data.listingLabel : data.levelTitle} />
                    {number && <CardNumber title={testingTitle}><span>no.</span> {number}</CardNumber>}
                </CardIndexHead>
                <CardIndexBody>
                    <CardLabel>{data.listingLabel}</CardLabel>
                    <CardTitle replaced={data.replaced}>{data.title}</CardTitle>
                </CardIndexBody>
                {type !== 'wait' && (
                    <CardButton theme={stateMap[state].theme}>
                        <span>{stateMap[state].label}</span>
                        <IconArrowRight />
                    </CardButton>
                )}
                { os.isOthers && lessons.lessonEditor() && (
                    <>
                        { data.lessonObject.editor && <EditorName>Editor: {data.lessonObject.editor.editedBy.name.split(' ')[0]}</EditorName> }
                        { viewCount && <ViewCount>{`Views: ${viewCount}`}</ViewCount> }
                        {/* { !data.lessonObject.editor && data.lessonObject.lessonNode.figmaFileName && <FigmaFilename>{data.lessonObject.lessonNode.figmaFileName}</FigmaFilename> } */}
                        <ResetButton type="button" onClick={resetLesson}>Reset</ResetButton>
                        {/* <RetireButton type="button" onClick={e => { e.stopPropagation(); setShowRetireConfirm(true); }}>Retire</RetireButton> */}
                        { data.lessonObject.editing
                            ? <EditButton type="button" disabled title={data.lessonObject.editing.editor.name}>editing</EditButton>
                            : <EditButton type="button" onClick={editLesson}>Edit</EditButton> }
                    </>
                )}
            </CardIndex>
            {/* ) : (
                <CardList>
                    <CardListTop onClick={() => setIndex(true)}>
                        {data.levelTitle && <LevelButtons level={data.levelTitle} />}
                        <ListTitle>{data.title}</ListTitle>
                        <ArrowButton type="button" />
                    </CardListTop>
                    { data.sections && data.sections.navMenu.map(section => (
                        <CardListItem key={section.index}><SectionButton to={sectionLink(section, data)}><LessonState state="play" />{section.title}</SectionButton></CardListItem>
                    ))}
                </CardList>
            )} */}
            { showRetireConfirm && (
                <PopupDialog
                    open={showRetireConfirm} setOpen={setShowRetireConfirm}
                    title="Confirm lesson retirement" onOK={deleteLesson} onCancel={e => { e.stopPropagation(); setShowRetireConfirm(false); }}
                >
                    {`Please confirm retirement of lesson "${data.title}".  This will retain all user progress history for the lesson but will remove it from all lesson lists.`}
                </PopupDialog>
            )}
        </LessonCardWrapper>
    );
};

export default LessonCard;